module.exports = __webpack_public_path__ + "img/comp-mu.cb71155c.svg";